import type { TokenStrategy } from './TokenStrategy'
import { readOnlyTokenStrategy } from './ReadOnlyTokenStrategy'
import { sessionTokenStrategy } from './SessionTokenStrategy'

export type TokenStrategyType = 'readOnly' | 'session'

export const TOKEN_STRATEGIES: Record<TokenStrategyType, TokenStrategy> = {
  readOnly: readOnlyTokenStrategy,
  session: sessionTokenStrategy,
} as const

/**
 * Gets the appropriate token strategy for the given type
 */
export function getTokenStrategy(type: TokenStrategyType): TokenStrategy {
  return TOKEN_STRATEGIES[type]
}
